import { createFileRoute, redirect } from "@tanstack/react-router";

type User = {
	id: number;
	name: string;
	email: string;
};

export const Route = createFileRoute("/flex/dashboard/$id")({
	component: RouteComponent,
	beforeLoad: ({ params }) => {
		if (!/^\d+$/.test(params.id)) {
			throw redirect({
				to: "/flex/dashboard/leads",
			});
		}
	},
	loader: async ({ params }) => {
		// Dummy API call using JSONPlaceholder
		const response = await fetch(
			`https://jsonplaceholder.typicode.com/users/${params.id}`,
		);
		if (!response.ok) {
			throw new Error("User not found");
		}
		return response.json() as Promise<User>;
	},
});

function RouteComponent() {
	const { id } = Route.useParams();
	const user = Route.useLoaderData();

	return (
		<div className="p-4">
			<h1 className="text-2xl font-bold mb-4">User Dashboard</h1>
			<div className="border rounded-lg p-4">
				<p>
					<strong>ID:</strong> {id}
				</p>
				<p>
					<strong>Name:</strong> {user.name}
				</p>
				<p>
					<strong>Email:</strong> {user.email}
				</p>
			</div>
		</div>
	);
}
